import "./InboundFlow.css";
import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { useContextStateManagement } from "../../context/ContextApi";
import { useDispatch } from "react-redux";
import { logout } from "../../features/userSlice";
import { useNavigate } from "react-router-dom";
// import { v4 as uuidv4 } from 'uuid';

export const UAT_Test = ({ formatDate, isDataGetWithDate, setIsDataGetWithDate, isCallsDataGet, setIsCallsDataGet, setIsDatesEmpty, isDatesEmpty, startDate, endDate, setUatTestGridData, uatTestGridData }) => {
    const [modalShow, setModalShow] = useState(false)
    const [activeModal, setActiveModal] = useState();
    const [userId, setUserId] = useState();
    const [menuId, setMenuId] = useState();
    const [callRecordings, setCallRecordings] = useState([]);
    const [callTranscriptions, setCallTranscriptions] = useState([]);
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const flagRef = useRef(false);
    const [transcriptRecord, setTranscriptRecord] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { PracticeId, outBoundContact, token, setActiveTab, usersPostRequest, fetchUserRecord, setSideBarLinkActive, setToken, dateRangeRequest, setUserType } = useContextStateManagement();

    const formatDateTime = (value) =>
        value ? moment(value).format("MM/DD/YYYY HH:mm:ss") : "-";

    const formatDuration = (value) => {
        const totalSeconds = Number(value || 0);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${String(seconds).padStart(2, "0")}`;
    };

    const formatLabel = (value) => {
        const formatted = String(value || "").toLowerCase();
        if (formatted === "no_answer") return "No Answer";
        return formatted
            .split("_")
            .filter(Boolean)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(" ");
    };

    const formatCost = (value, row) => {
        const amount = Number(value || 0);
        const currency = row?.PriceUnitNormalized || row?.PriceUnit || "USD";
        return `${amount.toFixed(4)} ${currency}`;
    };

    const columns = [
        {
            field: "DisplayStartedAt", headerName: "Started", width: 180, sortable: true, disableColumnMenu: true,
            renderCell: (params) => formatDateTime(params.value),
        },
        {
            field: "DisplayEndedAt", headerName: "Ended", width: 180, sortable: true, disableColumnMenu: true,
            renderCell: (params) => formatDateTime(params.value),
        },
        {
            field: "DurationSec", headerName: "Duration", width: 110, disableColumnMenu: true,
            renderCell: (params) => formatDuration(params.value),
        },
        {
            field: "PracticeDirection", headerName: "Practice Dir", width: 140, disableColumnMenu: true,
            renderCell: (params) => formatLabel(params.value),
        },
        { field: "Direction", headerName: "Twilio Dir", width: 160, disableColumnMenu: true },
        {
            field: "LegLevel", headerName: "Root/Child", width: 110, disableColumnMenu: true,
            renderCell: (params) => String(params.value || "").toUpperCase(),
        },
        { field: "From", headerName: "From", width: 220, filterable: true },
        { field: "To", headerName: "To", width: 260, filterable: true },
        {
            field: "StatusCategory", headerName: "Status", width: 130, disableColumnMenu: true,
            renderCell: (params) => formatLabel(params.value || params.row?.Status),
        },
        {
            field: "BilledAmount", headerName: "Cost", width: 130, disableColumnMenu: true,
            renderCell: (params) => formatCost(params.value, params.row),
        },
        { field: "RootCallSid", headerName: "Root Call SID", width: 260, disableColumnMenu: true },
        { field: "LegSid", headerName: "Leg SID", width: 260, disableColumnMenu: true },
    ];

    const menuHandle = (id) => {
        setMenuId(id)
        setModalShow(true)
        setActiveModal("menu");
    }

    const DoNotCallHandle = (id) => {
        setUserId(id)
        setModalShow(true)
        setActiveModal("doNotCall");
    }

    async function getCallsFetchHandle() {
        setIsDataGetWithDate(false);
        setUatTestGridData([]);
        flagRef.current = true;

        // let todayDate = new Date();
        // let threeDaysAgoDate = new Date(todayDate);
        // threeDaysAgoDate.setDate(todayDate.getDate() - 7);
        // let formatedStartDate = formatDate(threeDaysAgoDate);
        // let formatedEndDate = formatDate(todayDate);
        // console.log(practiceContactNumber)
        let obj = { fromContact: outBoundContact };
        const userData = await dateRangeRequest(token, `/api/getCalls`, obj);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else if (userData == "no record") {
            setUatTestGridData([]);
            setIsDataGetWithDate(true);
        }
        else {
            setUatTestGridData(userData);
            setIsDataGetWithDate(true);
            setIsCallsDataGet(true);
        }
    }

    async function addTwilioLogs() {
        const userData = await usersPostRequest(token, `/api/LoadDBFromTwilioDB`);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else if (userData == "no record") {
            console.log("no record")
        }
        else {
            // setCallRecordings(userData);
        }
    }

    async function getAllCallRecordings() {
        debugger;
        const userData = await fetchUserRecord(token, `/api/getCallRecordings`);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else if (userData == "no record") {
            setCallRecordings([]);
        }
        else {
            setCallRecordings(userData);
        }
    }

    async function getAllCallTranscriptions() {
        const userData = await fetchUserRecord(token, `/api/getCallTranscriptions`);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else {
            setCallTranscriptions(userData);
        }
    }

    let doNotCall = false;
    const cancelCallHandle = async (e) => {
        doNotCall = true;
        let id = userId;
        let obj = { doNotCall, id };
        let url = `/api/SurveyUploadLeadDoNotCall`;
        const userData = await usersPostRequest(token, url, obj);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else {
            getCallsFetchHandle()
            setModalShow(false)
        }
    }

    const allowCallHandle = async (e) => {
        doNotCall = false;
        let id = userId;
        let obj = { doNotCall, id };

        let url = `/api/SurveyUploadLeadDoNotCall`;
        const userData = await usersPostRequest(token, url, obj);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else {
            getCallsFetchHandle()
            setModalShow(false)
        }
    }

    // const getRowId = (row) => row.sid;

    async function handleSearchInputChange() {
        let url = `/api/SearchSurveyUploadLead`;
        let obj = { patientName, providerName, PracticeId }
        const userData = await usersPostRequest(token, url, obj);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else {
            setUatTestGridData(userData);
        }
    }

    const filterTranscriptRecord = () => {
        let callRecording;
        if (callRecordings && callRecordings.length > 0) {
            callRecording = callRecordings.filter((call) => call.callSid === menuId);
        }

        if (callRecording && callRecording.length > 0) {
            let transcription = callTranscriptions.filter((call) => call.recordingSid == callRecording[0].sid);
            let transcriptionText = transcription.length > 0 ? transcription[0].transcriptionText : "";
            setTranscriptRecord(transcriptionText);
        }
    }

    useEffect(() => {
        if (menuId != null) {
            filterTranscriptRecord()
        }
    }, [menuId])

    useEffect(() => {
        if (flagRef.current === false || PracticeId) {
            // debugger;
            getCallsFetchHandle();
            // addTwilioLogs();
        }
    }, [flagRef, PracticeId])

    // useEffect(() => {
    //     if (isCallsDataGet === false) {
    //         getAllCallRecordings();
    //     }
    // }, [isCallsDataGet])

    // useEffect(() => {
    //     if (isCallsDataGet === false) {
    //         getAllCallTranscriptions();
    //     }
    // }, [isCallsDataGet])

    // Token-expiry redirect is now handled once, centrally, in ContextApi.js - see its comment
    // for why this component's own copy of the same effect was removed.

    // useEffect(() => {
    //     if (startDate || endDate) {
    //         setSideBarLinkActive("careConsole");
    //         handleStartDateChange();
    //         setIsDatesEmpty(false);
    //     }
    // }, [startDate, endDate])

    // useEffect(() => {
    //     if (!startDate && !endDate && isDatesEmpty === true && isCallsDataGet === true) {
    //         getCallsFetchHandle();
    //         setIsDatesEmpty(false);
    //     } else {
    //         setIsDatesEmpty(false);
    //     }
    // }, [startDate, endDate, isDatesEmpty, isCallsDataGet])

    return (
        <>
            <div className="grid-layout">
                <DataGrid
                    rows={uatTestGridData ? uatTestGridData : []}
                    rowHeight={56}
                    columns={columns}
                    autoWidth
                    pageSizeOptions={[10, 25, 50, 100]}
                    loading={isDataGetWithDate === false}
                    disableColumnSelector
                    disableDensitySelector
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: true },
                        },
                    }}
                    getRowId={(row) => row.LegSid || row.Sid || row.Id}
                    // disableColumnSorting
                    disableColumnMenu
                />
            </div>
            <Modal className="popup" show={modalShow} onHide={() => setModalShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title> {activeModal === "menu" ? "Transcripts" : "Cancel Call "}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeModal === "menu" ? <p>{transcriptRecord ? transcriptRecord : "No Transcript of current Record"}</p> : <p>Are you sure that you can't call this lead</p>}
                </Modal.Body>
                <Modal.Footer>
                    {
                        activeModal !== "menu" ?
                            <button className="simple-btn me-2" id="closeTrue" onClick={allowCallHandle}>No</button> :
                            <button className="simple-btn" onClick={() => setModalShow(false)}>Close</button>
                    }
                    {activeModal !== "menu" ?
                        <button className="simple-btn" id="updateTrue" onClick={cancelCallHandle}>Yes</button> :
                        ""
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}


